import React from 'react';
import { Layers } from 'lucide-react';

interface PhaseOption {
  value: string;
  label: string;
  apiValue: number | null; // null means all phases
}

export const PHASE_OPTIONS: PhaseOption[] = [
  { value: '', label: 'All Phases', apiValue: null },
  { value: '1', label: 'Phase 1', apiValue: 1 },
  { value: '2', label: 'Phase 2', apiValue: 2 },
  { value: '3', label: 'Phase 3', apiValue: 3 },
  { value: '5', label: 'Phase 5', apiValue: 5 },
  { value: '7', label: 'Phase 7', apiValue: 7 },
];

interface PhaseDropdownProps {
  value: number | null;
  onChange: (value: number | null) => void;
  className?: string;
  showIcon?: boolean;
}

const PhaseDropdown: React.FC<PhaseDropdownProps> = ({
  value,
  onChange,
  className = '',
  showIcon = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    if (selectedValue === 'all') {
      onChange(null);
    } else {
      onChange(parseInt(selectedValue));
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showIcon && <Layers className="w-4 h-4 text-gray-500" />}
      <select
        value={value === null ? 'all' : value.toString()}
        onChange={handleChange}
        className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent cursor-pointer hover:bg-gray-50"
        aria-label="Select Phase"
      >
        {PHASE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PhaseDropdown;
